import { ITableFilter, FilterDataType, IFilterTable } from "../filter.objects";
import { PickListItem, JsonItem } from "../../../entities/pick-list/pick-list.entities"
import { DoArraysOverlap } from "../../../scripts/array-functions";
import _ from "lodash";
export class MultiselectFilter implements ITableFilter {
    filterId: string; 
    displayName: string; 
    propertyName: string;

    filterOptions: MultiselectFilterOptions;
    filterTable: IFilterTable;

    constructor(filterId: string, displayName: string, propertyName: string, options: MultiselectFilterOptions) {
        this.filterId = filterId;
        this.displayName = displayName;
        this.propertyName = propertyName;
        this.filterOptions = options;
    }

    initialize(items: any[], filterTable: IFilterTable) {
        this.filterTable = filterTable;
        this.initializeDropdown(items);
        this.initializeFilter();
    }

    generateFilterHtml(): string {
        let liveSearch = "";
        if (this.filterOptions.liveSearch) {
            liveSearch = `data-live-search="true"`;
        }

        let html = `
            <div id="${this.filterId}-select" class="col-12 ${this.filterOptions.className}">
                <div id="${this.filterId}-block" class="filter-label d-inline-block label-only">${this.displayName}</div>
                <select id="${this.filterId}-dropdown" class="selectpicker dropdown" title="None Selected" data-actions-box="true" data-width="100%" data-container="body" data-size="10"  ${liveSearch} multiple>
                </select>
            </div>
        `;

        return html;
    }

    private initializeDropdown(items: any[]): void {
        let selectId = `#${this.filterId}-dropdown`;

        if (this.filterOptions.dataType == FilterDataType.String) {
            let options: any[] = items.map(item => _.get(item, this.propertyName));
            let uniqueOptions = _.uniq(options);
            uniqueOptions = uniqueOptions.map(option => {
                if (!option) {
                    return "--None--";
                }
                return option;
            });
            uniqueOptions.sort((x1: string, x2: string) => {
                if (x1.startsWith("-") && !x2.startsWith("-")) {
                    return 1;
                }
                else if (x2.startsWith("-") && !x1.startsWith("-")) {
                    return -1;
                }
                else {
                    return x1.localeCompare(x2);
                }
            });
            $(selectId).selectpicker({
                dropupAuto: false,
                selectedTextFormat: "count",

                countSelectedText: (numSelected, numTotal) => {
                    if (numSelected == numTotal) {
                        return "All";
                    }
                    else {
                        return numSelected + " Selected";
                    }
                }
            });

            uniqueOptions.forEach(option => {
                $(selectId).append(new Option(option, option, false, this.filterOptions.defaultAllSelected));
            })

            $(selectId).selectpicker("refresh");
        }
        else if (this.filterOptions.dataType == FilterDataType.Number) {
            let optionIds: number[] = items.map(item => _.get(item, this.propertyName));
            let uniqueOptionIds = _.uniq(optionIds);
            let pickList: PickListItem[] = this.filterTable.pickLists.find(list => list.Id == this.filterOptions.pickListId).Json;
            if (pickList) {
                let options: string[][] = uniqueOptionIds.map(optionId => {
                    if (!optionId) {
                        optionId = 0;
                    }
                    let foundOptionList = pickList.find(item => item.Id == optionId);
                    let foundOption = "--None--"
                    if (foundOptionList) {
                        foundOption = foundOptionList.Value;
                    }
                    return [optionId.toString(), foundOption];
                });
                options.sort((x1: string[], x2: string[]) => {
                    if (x1[1].startsWith("-") && !x2[1].startsWith("-")) {
                        return 1;
                    }
                    else if (x2[1].startsWith("-") && !x1[1].startsWith("-")) {
                        return -1;
                    }
                    else {
                        return x1[1].localeCompare(x2[1]);
                    }
                });
                $(selectId).selectpicker({
                    dropupAuto: false,
                    selectedTextFormat: "count",

                    countSelectedText: (numSelected, numTotal) => {
                        if (numSelected == numTotal) {
                            return "All";
                        }
                        else {
                            return numSelected + " Selected";
                        }
                    }
                });
                options.forEach(option => {
                    $(selectId).append(new Option(option[1], option[0], false, this.filterOptions.defaultAllSelected));
                })

                $(selectId).selectpicker("refresh");
            }
        }
        else if (this.filterOptions.dataType == FilterDataType.PipePathSeparatedStrings) {
            let options: string[] = [];
            items.forEach(item => {
                let foundTarget: string = _.get(item, this.propertyName);
                if (foundTarget) {
                    let optionArr = foundTarget.split("|");
                    if (optionArr.length > 0) {
                        optionArr.forEach(option => {
                            if (option) {
                                options.push(option);
                            }
                        })
                    }
                    else {
                        options.push("--None--");
                    }
                }
            });

            let uniqueOptions = _.uniq(options);
            uniqueOptions.sort((x1: string, x2: string) => {
                if (x1.startsWith("-") && !x2.startsWith("-")) {
                    return 1;
                }
                else if (x2.startsWith("-") && !x1.startsWith("-")) {
                    return -1;
                }
                else {
                    return x1.localeCompare(x2);
                }
            });
            $(selectId).selectpicker({
                dropupAuto: false,
                selectedTextFormat: "count",

                countSelectedText: (numSelected, numTotal) => {
                    if (numSelected == numTotal) {
                        return "All";
                    }
                    else {
                        return numSelected + " Selected";
                    }
                }
            });
            uniqueOptions.forEach(option => {
                $(selectId).append(new Option(option, option, false, this.filterOptions.defaultAllSelected));
            })
            $(selectId).selectpicker("refresh");
        }
        else if (this.filterOptions.dataType == FilterDataType.PipePathSeparatedIds) {
            let optionIdStrings: string[] = items.map(item => _.get(item, this.propertyName));
            let uniqueOptionIdStrings = _.uniq(optionIdStrings);
            let uniqueOptionNames: string[] = [];
            let options: string[][] = [];
            let pickList: PickListItem[] = this.filterTable.pickLists.find(list => list.Id == this.filterOptions.pickListId).Json;
            if (pickList) {
                for (let i = 0; i < uniqueOptionIdStrings.length; i++) {
                    let optionString: string = uniqueOptionIdStrings[i];
                    if (!optionString) {
                        optionString = "0"
                    }

                    let optionIdArr: string[] = optionString.split("|");
                    for (let j = 0; j < optionIdArr.length; j++) {
                        let optionId = optionIdArr[j];
                        let foundOptionList = pickList.find(item => item.Id.toString() == optionId);
                        let foundOption = "--None--"
                        if (foundOptionList) {
                            foundOption = foundOptionList.Value;
                        }
                        if (!uniqueOptionNames.includes(foundOption)) {
                            options.push([optionId, foundOption]);
                            uniqueOptionNames.push(foundOption);
                        }
                    }
                }
            }
            options.sort((x1: string[], x2: string[]) => {
                if (x1[1].startsWith("-") && !x2[1].startsWith("-")) {
                    return 1;
                }
                else if (x2[1].startsWith("-") && !x1[1].startsWith("-")) {
                    return -1;
                }
                else {
                    return x1[1].localeCompare(x2[1]);
                }
            });
            $(selectId).selectpicker({
                dropupAuto: false,
                selectedTextFormat: "count",

                countSelectedText: (numSelected, numTotal) => {
                    if (numSelected == numTotal) {
                        return "All";
                    }
                    else {
                        return numSelected + " Selected";
                    }
                }
            });
            options.forEach(option => {
                $(selectId).append(new Option(option[1], option[0], false, this.filterOptions.defaultAllSelected));
            })

            $(selectId).selectpicker("refresh");
        }
        else if (this.filterOptions.dataType == FilterDataType.YesNo) {
            let options: string[][] = [["1", "Yes"], ["0", "No"]];
            $(selectId).selectpicker({
                dropupAuto: false,
                selectedTextFormat: "count",

                countSelectedText: (numSelected, numTotal) => {
                    if (numSelected == numTotal) {
                        return "All";
                    }
                    else {
                        return numSelected + " Selected";
                    }
                }
            });
            options.forEach(option => {
                $(selectId).append(new Option(option[1], option[0], false, this.filterOptions.defaultAllSelected));
            })
            $(selectId).selectpicker("refresh");
        }
    }

    private initializeFilter() {
        let selectId = `#${this.filterId}-dropdown`;
        $(selectId).on('changed.bs.select', (e, clickedIndex, isSelected, previousValue) => {
            this.filterTable.triggerFilter();
        });
    }

    filterItems(items: any[]): any[] {
        let selectId = `#${this.filterId}-dropdown`;
        let selectedItems = <string[]>$(selectId).val();

        if (!this.filterOptions.defaultAllSelected) {
            // If nothing is selected, no filtering
            if (selectedItems.length == 0) {
                return items;
            }
        }

        if (this.filterOptions.dataType == FilterDataType.String) {
            selectedItems = selectedItems.map(item => {
                if (item == "--None--") {
                    return "";
                }
                else {
                    return item;
                }
            })
            let filteredItems = items.filter(item => selectedItems.includes(_.get(item, this.propertyName)));
            return filteredItems;
        }

        else if (this.filterOptions.dataType == FilterDataType.Number) {
            let parsedValues: number[] = [];

            selectedItems.forEach(val => parsedValues.push(parseInt(val)));

            let filteredItems = items.filter(item => {
                let itemVal = _.get(item, this.propertyName);
                if (!itemVal) { itemVal = 0; }
                return parsedValues.includes(itemVal);
            });
            return filteredItems;
        }

        else if (this.filterOptions.dataType == FilterDataType.PipePathSeparatedStrings) {   
            let filteredItems = items.filter(item => {
                let val: string = _.get(item, this.propertyName);
                if (!val) val = "--None--";
                    
                let valArr: string[] = val.split("|");
                if (valArr.length == 0) {
                    valArr = ["--None--"];
                }
                
                return DoArraysOverlap(selectedItems, valArr);
            })

            return filteredItems;
        }

        else if (this.filterOptions.dataType == FilterDataType.PipePathSeparatedIds) {
            let filteredItems = items.filter(item => {
                let val: string = _.get(item, this.propertyName);
                if (!val) val = "0";

                let valArr: string[] = val.split("|");
                if (valArr.length == 0) {
                    valArr = ["0"];
                }

                return DoArraysOverlap(selectedItems, valArr);
            });

            return filteredItems;
        }

        else if (this.filterOptions.dataType == FilterDataType.YesNo) {
            let parsedValues: boolean[] = [];
            selectedItems.forEach(item => {
                if (item == "1") {
                    parsedValues.push(true);
                }
                else if (item == "0") {
                    parsedValues.push(false)
                }
            });

            let filteredItems = items.filter(item => {
                return DoArraysOverlap(parsedValues, [_.get(item, this.propertyName)]);
            });
            return filteredItems;
        }

        return items;
    }

    getSelected(): string | string[] | number {
        let selectId = `#${this.filterId}-dropdown`;
        let selectedValues = <string[]>$(selectId).val();
        let totalOptionsCount = $(selectId).find("option").length;
        if (totalOptionsCount == selectedValues.length) {
            selectedValues = ["All"];
        }
        return selectedValues;
    }

    setSelected(selectedValues: string | string[] | number): void {
        let selectId = `#${this.filterId}-dropdown`;
        let selectedValuesCount = (<string[]>selectedValues).length;
        if (selectedValuesCount == 1) {
            if (selectedValues[0] == "All") {
                $(selectId).selectpicker("selectAll").trigger("change");
            }
            else {
                $(selectId).val(selectedValues);
                $(selectId).selectpicker("refresh").trigger("change");
            }
        }
        else {
            $(selectId).val(selectedValues);
            $(selectId).selectpicker("refresh").trigger("change");
        }
    }

    resetFilter(): void {
        let selectId = `#${this.filterId}-dropdown`;
        if (this.filterOptions.defaultAllSelected) {
            $(selectId).selectpicker("selectAll");
        }
        else {
            $(selectId).selectpicker("deselectAll");
        }
    }
}

export class MultiselectFilterOptions {
    isPickList: boolean = false; // If options should be from picklist
    pickListId: string; // Id of the picklist to use
    dataType: FilterDataType = 1; // Default to string data
    liveSearch: boolean = false; // Should filter include live search
    defaultAllSelected: boolean = false; // Should all items be selected by default (if false, nothing selected is equivalent to all selected)
    className: string = "col-md-3 mb-2"; // ClassNames to include on the filter (used for sizing the filter or styling)

    constructor(isPickList: boolean = false, pickListId: string, dataType: FilterDataType = 1, liveSearch: boolean = false, defaultAllSelected: boolean = true, className: string = "col-md-3 mb-2") {
        this.isPickList = isPickList;
        this.pickListId = pickListId;
        this.dataType = dataType;
        this.liveSearch = liveSearch;
        this.defaultAllSelected = defaultAllSelected;
        this.className = className;
    }
}